import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class ConfigurationIssue extends AlertLogic {
    static type:AlertType|AlertType[] = AlertType.ConfigurationIssue;
    static title = Locale.gettext('Configuration Issue');
    static contentCategories = [ ContentCategories.SYSTEM_ERROR ];

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;

        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        const entityName = body.Name === 'BodyUuid: -' ? this.locale.gettext('The Attendant') : body.Name;

        // Varying across alert types
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Configuration Issue'),
            cardDescription: this.locale.gettext('There is an issue with the configuration of %1$s', entityName),
            cardIllustration: 'pool_reading_document',
            detailIcon: 'cogs',
            detailDescription: this.locale.gettext('There is an issue with the configuration of %1$s, please review the configuration and correct any issues.\n[%2$s]', entityName, body.Name),
            resolveSummary: this.locale.gettext('Configuration issue was resolved')
        });
        alertInfo.contentCategories = ConfigurationIssue.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.BodiesOfWater[0];
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {}
        }) : null;
    }
}